import { TFunction } from 'i18next'
import { z } from 'zod'

import { doesStringContainHtml } from '../../../utils/doesStringContainHtml'
import { DemoInvoiceSendAsEmailFormSchema } from '../types/demoInvoiceSendAsEmailFormSchema'

export const getDemoInvoiceSendAsEmailFormSchema = (t: TFunction): DemoInvoiceSendAsEmailFormSchema =>
  z.object({
    emailMessage: z
      .string()
      .optional()
      .refine((value) => !doesStringContainHtml(value), {
        message: t('external_invoices.send_as_email.modal.form.validation.contains_html'),
      }),
    emailRecipient: z.string(),
    emailSubject: z
      .string()
      .min(1, { message: t('external_invoices.send_as_email.modal.form.validation.subject_required') })
      .refine((value) => !doesStringContainHtml(value), {
        message: t('external_invoices.send_as_email.modal.form.validation.contains_html'),
      }),
  })
